const getImageFileName = (original) => {
    return original?.replaceAll(/[\\\/\:\*\?\"\<\>\|\s]/g, "");
};

export default getImageFileName;
